import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var BusinessAnalyticsOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M12 2C6.489 2 2 6.489 2 12C2 17.511 6.489 22 12 22C17.511 22 22 17.511 22 12C22 6.489 17.511 2 12 2ZM11 4.06836V6H13V4.06836C16.6261 4.51814 19.4819 7.37392 19.9316 11H16V13H19.9316C19.7503 14.4622 19.1778 15.797 18.3203 16.9023L16.1055 14.6113C16.0855 15.5153 15.8305 16.2315 15.4375 16.7715L16.9082 18.3164C15.5539 19.3689 13.8546 20 12 20C7.56988 20 4 16.4301 4 12C4 7.90935 7.04577 4.55885 11 4.06836ZM11 7V8.12109C10.3281 8.33515 9.31055 8.90919 9.31055 10.4355C9.31055 13.4595 12.7383 12.564 12.7383 14.582C12.7383 15.593 12.0249 15.6172 11.8789 15.6172C11.7459 15.6172 10.873 15.546 10.873 14H9C9 16.1133 10.3149 16.7249 11 16.9102V18H13V16.8535C13.6732 16.6278 14.6113 16.057 14.6113 14.5703C14.6113 11.6693 11.1846 12.2244 11.1836 10.4434C11.1836 9.42336 11.7986 9.39062 11.9316 9.39062C12.1746 9.39062 12.752 9.757 12.752 11H14.625C14.625 9.22651 13.6353 8.47428 13 8.18359V7H11Z",
    fill: fill
  }));
};
export { BusinessAnalyticsOutline as default };
//# sourceMappingURL=BusinessAnalyticsOutline.js.map
